module.exports = __webpack_public_path__ + "cf2f921a1fa8fb52d673dcb46ffff27b.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/1000_r_20.mp3
// module id = 433
// module chunks = 0